/* eslint-disable react-hooks/rules-of-hooks */
import { useChatState } from 'app/store/chat/state';
export const selectMessages = () => useChatState((state) => state.messages);
export const selectIsGettingMessages= () => useChatState((state) => state.isLoading);
export const selectPage = () => useChatState((state)=>state.meta?.current_page)
export const selectPerPage = () => useChatState((state)=>state.meta?.per_page)
export const selectAbilityToUpdateChat = () => useChatState((state)=>state.meta?.current_page!==state.meta?.last_page)